module.exports = __webpack_public_path__ + "./img/area.1a72e0aa.png";